<script>
    export let open

    function click(e) {
        if (open) {
            open = false
        } else {
            open = true
        }
    }
</script>

<button on:click={click} class="extra circle transparent"><i>{open ? "menu_open" : "menu"}</i></button>
